<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="include ? 'Include bearbeiten' : 'Include hinzufügen'"
                :ok-disabled="!validate || readOnly"
                :loading="loading"
                @ok="submit"
                @cancel="close">
            <Dropdown v-model="sitetypes" label="Sitetype" :items="includeSitetypes" item-text="name"
                      item-value="sitetype_id">
            </Dropdown>
            <Input v-model="sitetype" label="Sitetype"
                   :error-messages="sitetypeErrors"
                   :required="true"
                   :loading="includeDetailsLoading"
                   @input="$v.sitetype.$touch()"
                   @blur="$v.sitetype.$touch()"></Input>
            <template v-slot:button v-if="include && !readOnly">
                <Button :text="true" :color="ada.red"
                        @click="$emit('delete')">
                    Löschen
                </Button>
            </template>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Include erfolgreich hinzugefügt.</Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Input from "../../../components/Inputs/Input";
import ada from "../../../scss/ada_colors.scss";
import Dropdown from "../../../components/Inputs/Dropdown";
import Utils from "../../../scripts/Utils";
import Button from "../../../components/buttons/Button";

export default {
    name: "IncludeDialog",
    components: {Button, Dropdown, Input, Snackbar, Dialog},
    props: ['value', 'include', 'includeDetails', 'includeDetailsLoading'],
    mixins: [validationMixin],
    validations: {
        sitetype: {required},
    },
    data: () => {
        return {
            loading: false,
            successSnackbar: false,
            includeSitetypes: [],
            sitetypes: null,
            sitetype: null,
            ada
        }
    },
    mounted() {
        this.fetchIncludeDetails()
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        sitetypeErrors() {
            return Utils.handleError(this, 'sitetype', 'Sitetype ist erforderlich.');
        },
        validate() {
            return this.sitetypeErrors.length === 0;
        },
        readOnly() {
            return this.$store.state.readOnly === 1;
        },
    },
    methods: {
        init() {
            this.sitetypes = this.include ? this.includeSitetypes.find(x => x.name === this.include.Name) : this.includeSitetypes[0];
            this.sitetype = this.includeDetails ? this.includeDetails.IncludeSiteType : null;
        },
        async fetchIncludeDetails() {
            let data = await this.$store.dispatch('display/fetchIncludeDetails');
            this.includeSitetypes = data.SiteTypes;
            this.init();
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data;
                try {
                    data = await this.$store.dispatch('display/saveInclude', this.getBody());
                    this.loading = false;
                    if (data.Status) {
                        this.successSnackbar = true;
                        this.close();
                    }
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                include_id: this.sitetypes.sitetype_id,
                includeSiteType: this.sitetype
            }
        },
        close() {
            this.init();
            this.$emit('input', false);
        }
    },
    watch: {
        include() {
            this.init();
        },
        includeDetails() {
            this.init();
        }
    }
}
</script>

<style scoped>

</style>